import { useTranslation } from 'react-i18next';
import TableEmptyRow from 'components/others/TableEmptyRow';
import HistoryDeadlineTableRow from './HistoryDeadlineTableRow';
import type { HistoryDeadlineRow } from './model';

interface HistoryDeadlineTableBodyProps {
    rows: HistoryDeadlineRow[];
    loading: boolean;
}

const HistoryDeadlineTableBody = ({ rows, loading }: HistoryDeadlineTableBodyProps) => {
    const { t } = useTranslation(['Objects']);

    if (!rows.length) {
        return (
            <tbody>
                <TableEmptyRow colSpan={4} className="text-center text-muted py-4">
                    {loading ? '\u00A0' : t('historyDeadline.empty')}
                </TableEmptyRow>
            </tbody>
        );
    }

    return (
        <tbody>
            {rows.map((row) => (
                <HistoryDeadlineTableRow key={row.ID} row={row} />
            ))}
        </tbody>
    );
};

export default HistoryDeadlineTableBody;
